<template>
  <div>
    <v-toolbar
      flat
      color="white"
      class="mx-0 px-0"
    >
      <v-spacer />
      <v-btn
        color="info"
        small
        icon
        @click="toggleFilters"
      >
        <v-icon>{{ filterEnabled ? 'mdi-close' : 'mdi-filter-variant' }}</v-icon>
      </v-btn>
      <v-btn
        v-if="!certifiedLaborer"
        color="success"
        rounded
        icon
        small
        :disabled="!canCreate && !propsOrganization"
        @click="goToForm"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card v-show="filterEnabled && !loading">
      <WBDVacancyListFilter
        :vacancy-list-filter-set="vacancyListFilterSet"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="getVacancyList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
    <div
      v-if="certifiedLaborer"
    >
      <v-alert
        v-if="!certificationFilterEnabled"
        prominent
        text
        dense
        class="py-1 my-1"
        type="info"
      >
        <v-row align="center">
          <v-col class="grow">
            <span style="font-size: 0.9em; display: block">
              Это режим общего поиска вакансии. В этот режим вы видите все вакансии по фильтрам,
              и можете их управлять обучением данного соискателя
            </span>
          </v-col>
        </v-row>
      </v-alert>
      <v-alert
        v-else
        prominent
        text
        dense
        class="py-1 my-1"
        type="info"
      >
        <v-row align="center">
          <v-col class="grow">
            <span style="font-size: 0.9em; display: block">
              Это режим списка вакансии где данный соискатель прошел обучение. Для поиска новых вакансии
              переходите в режим общего поиска.
            </span>
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <v-card-actions v-if="!loading">
      <v-switch
        v-if="certifiedLaborer"
        v-model="certificationFilterEnabled"
        inset
        color="orange"
      >
        <template v-slot:label>
          <span class="orange--text">
            Показать только обученные вакансии
          </span>
        </template>
      </v-switch>
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.supportNumber="{ item }">
        <ItemLinkView
          :label="undefined"
          :value="getViewRouteData(item)"
          :link-text="`${item.supportNumber || ' '}`"
        />
      </template>
      <template v-slot:item.title="{ item }">
        <span
          v-if="item.code"
          style="font-size: small; color: gray"
          class="text--gray"
        >{{ `[${item.code}] ` }}</span>
        <span>{{ item.title }}</span>
      </template>
      <template v-slot:item.isComplete="{ item }">
        <span
          v-if="!!item.isComplete"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.hasManualAgreement="{ item }">
        <span
          v-if="!!item.hasManualAgreement"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.isPrivate="{ item }">
        <span
          v-if="!!item.isPrivate"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.hasQuestionList="{ item }">
        <span
          v-if="!!item.hasQuestionList"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.requiredMedicalBook="{ item }">
        <span
          v-if="!!item.requiredMedicalBook"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.hourlyPay="{ item }">
        <span>{{ !!item.regionSetting && item.regionSetting.length ? `${item.regionSetting.length}` : 0 }}</span>

        <!--        <span-->
        <!--          v-if="!!item.regionSetting && item.regionSetting.length"-->
        <!--          class="green&#45;&#45;text"-->
        <!--        >-->
        <!--          <span-->
        <!--            v-for="setting in item.regionSetting"-->
        <!--            :key="setting.id"-->
        <!--            style="display: block"-->
        <!--          >-->
        <!--            <span>{{ `${setting.region.title}: ${setting.payPerHour}` }}</span>-->
        <!--          </span>-->
        <!--        </span>-->
      </template>
      <template v-slot:item.selfEmployerHourlyPay="{ item }">
        <span>{{ !!item.regionSetting && item.regionSetting.length ? `${item.regionSetting.length}` : 0 }}</span>
        <!--        <span-->
        <!--          v-if="!!item.regionSetting && item.regionSetting.length"-->
        <!--          class="green&#45;&#45;text"-->
        <!--        >-->
        <!--          <span-->
        <!--            v-for="setting in item.regionSetting"-->
        <!--            :key="setting.id"-->
        <!--          >-->
        <!--            {{ `${setting.region.title}: ${setting.selfEmployerPay}` }}-->
        <!--          </span>-->
        <!--        </span>-->
      </template>
      <template v-slot:item.message="{ item }">
        <v-tooltip
          v-if="renderMessage(item.message)"
          bottom
          dark
          max-width="360"
        >
          <template v-slot:activator="{ on }">
            <span
              style="text-decoration: underline; cursor: pointer"
              v-on="on"
            >
              {{ `${getMessage(item.message) || ''}` }}
            </span>
          </template>
          <span
            style="display: inline-block; color: #FFFFFF; background-color: black !important; padding: 12px"
          >{{ `${item.message}` }}</span>
        </v-tooltip>
        <span v-else>{{ `${item.message || ''}` }}</span>
      </template>
      <template v-slot:item.selfEmployeeOnly="{ item }">
        <span
          v-if="!!item.selfEmployeeOnly"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.organization="{ item }">
        <a
          target="_blank"
          style="text-decoration: none"
          @click.stop="gotoOrganizationView(item.organization.id)"
        >
          <span class="mr-1"> {{ item.organization.title }}</span>
          <v-icon
            style="color: inherit"
            x-small
          >fa-eye</v-icon>
        </a>
      </template>
      <template v-slot:item.certification="{ item }">
        <span
          v-if="!!item.certification && !!item.certification.id"
          class="green--text"
        >Да</span>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template v-slot:item.hasQuestionList="{ item }">
        <v-btn
          v-if="!!item.hasQuestionList"
          icon
          color="info"
          x-small
          @click="activeLaborerBlockModal(item)"
        >
          <v-icon>fa-eye</v-icon>
        </v-btn>
        <span
          v-else
          class="red--text"
        >Нет</span>
      </template>
      <template
        v-slot:item.options="{ item }"
      >
        <v-card-actions>
          <v-btn
            text
            outlined
            rounded
            small
            color="success"
            @click="gotoView(item)"
          >
            <v-icon class="mr-1">
              mdi-eye
            </v-icon>
          </v-btn>
        </v-card-actions>
      </template>
      <template
        v-if="certifiedLaborer"
        v-slot:item.actions="{ item }"
      >
        <CreateLaborerCertificationDrawer
          ref="createLaborerCertificationRef"
          :vacancy-certification="item.certification"
          :laborer="{
            ...certifiedLaborer,
            vacancyCertification: item.laborerCertification
          }"
          @onCreateLaborerCertificationModalSuccess="(data) => manageCertification(data, item)"
        />
      </template>
    </v-data-table>
    <VacancyQuestionModal
      v-if="selectedVacancy && laborerBlockModalActive"
      :display-self.sync="laborerBlockModalActive"
      :vacancy="selectedVacancy"
      @onCloseVacancyQuestionListModal="closeCurrentVacancy"
    />
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import { offerDate } from '@/utils/dateUtl'
import VacancyQuestionModal from '@/views/organization/vacancy-question-modal'
import WBDVacancyListFilter from '@/components/common/filter/vacancy-list-filter'
import { pluriaizeRows } from '@/utils/plural-util'
import routeList from '@/router/labels'
import { CLIENT_VACANCY_CREATED_ROUTE_NAME } from '@/router/client'
import CreateLaborerCertificationDrawer from '@/views/vacancy/create-vacancy-certifiction-modal-drawer.vue'
import LaborerCertificationMixin from '@/mixins/laborer-certification-mixin.vue'

export default {
  name: 'WBDVacancyListPage',
  components: { VacancyQuestionModal, WBDVacancyListFilter, CreateLaborerCertificationDrawer },
  mixins: [ListMixin, DictionaryMixin, LaborerCertificationMixin],
  props: {
    propsOrganization: {
      type: Object,
    },
    certifiedLaborer: {
      type: Object,
    }
  },
  data: () => ({
    filterEnabled: false,
    certificationFilterEnabled: {
      type: Boolean,
    },
    vacancyListFilterSet: {
      organization: null,
      region: null,
      isActive: null,
      vacancyProfession: null,
      state: null,
      searchQuery: null,
    },
    selectedVacancy: undefined,
    laborerBlockModalActive: false,
    loading: true,
    paginatorTotal: null,
    modelList: [],
    selectedRegion: null,
    editModalShowMode: false,
    options: {},
    smsListFilterSet: {
      searchQuery: null,
    },
    headers: [
      { text: '', value: 'actions' },
      { text: 'номер', value: 'supportNumber' },
      { text: 'Создана', value: 'dateString' },
      { text: 'Клиент', value: 'organization' },
      {
        text: 'Название',
        align: 'left',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Внешнее наз.',
        align: 'left',
        sortable: false,
        value: 'externalTitle',
      },
      { text: 'Ставка физ', value: 'hourlyPay', sortable: false },
      { text: 'Ставка смз', value: 'selfEmployerHourlyPay', sortable: false },
      { text: 'Профессия', value: 'profession.title', sortable: false },
      { text: 'Сообщение по вакансии', value: 'message', sortable: false },
      { text: 'Обучение', value: 'certification', sortable: false },
      { text: 'Нужна ли ЛМК', value: 'requiredMedicalBook', sortable: false },
      { text: 'Вопросы по вакансии', value: 'hasQuestionList', sortable: false },
      { text: 'Для СМЗ', value: 'selfEmployeeOnly', sortable: false },
      { text: 'Смены для своих', value: 'isPrivate', sortable: false },
      { text: 'Активная', value: 'isComplete', sortable: false },
      { text: 'Ручное согласование оплаты', value: 'hasManualAgreement', sortable: false },
      { text: '', value: 'options' },
    ],

  }),
  computed: {
    canCreate () {
      let organization
      if (this.propsOrganization) {
        organization = this.propsOrganization
      } else {
        organization = this.vacancyListFilterSet.organization
      }
      return !!organization && !!organization.id
    },
    searchResultLabel () {
      return `Найдено: ${this.paginatorTotal} ${pluriaizeRows(this.paginatorTotal)}`
    },
    getActiveFilterNumber () {
      const params = {
        ...this.vacancyListFilterSet
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
  },
  watch: {
    options: {
      handler () {
        this.getVacancyList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async created () {
    if (this.certifiedLaborer) {
      this.certificationFilterEnabled = true
    }
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
  },
  methods: {
    getViewRouteData (item) {
      return this.$router.resolve(
        {
          name: CLIENT_VACANCY_CREATED_ROUTE_NAME,
          params: { id: item.id, organizationId: item.organization.id }
        }
      ).href
    },
    activeLaborerBlockModal (selectedVacancy) {
      this.selectedVacancy = selectedVacancy
      this.laborerBlockModalActive = true
    },
    closeCurrentVacancy () {
      this.selectedVacancy = null
      this.laborerBlockModalActive = false
    },
    renderDateTime (date) {
      if (!date) {
        return ''
      }
      return offerDate(date, 'DD MMMM YYYY')
    },
    onCloseEditModalShowMode (save) {
    },
    async save () {
    },
    async getVacancyList (page, size) {
      try {
        const params = { 'page[number]': page, 'page[size]': size }

        const { organization, region, vacancyProfession, isActive, state, searchQuery } = this.vacancyListFilterSet

        this.modelList = []
        // const { sortBy, sortDesc } = this.options
        //
        // if (sortBy && sortBy.length) {
        //   for (const [index, item] of sortBy.entries()) {
        //     params[`ordering[${item}]`] = sortDesc[index] ? 'DESC' : 'ASC'
        //   }
        // }
        //
        // const { searchQuery } = this.smsListFilterSet
        //
        // if (searchQuery && searchQuery.trim().length > 0) {
        //   params.searchQuery = searchQuery
        // }
        this.loading = true

        if (!this.certificationFilterEnabled) {
          params.ignoreLaborer = true
        }

        if (this.certifiedLaborer) {
          const currentStateFilter = state || []
          currentStateFilter.push('certification')
          params.state = currentStateFilter
          params['laborer[id]'] = this.certifiedLaborer.id
        } else if (state && state.length) {
          params.state = state
        }
        if (this.propsOrganization && this.propsOrganization.id) {
          params['organization[id]'] = this.propsOrganization.id
        } else if (organization) {
          params['organization[id]'] = organization.id
        }
        if (vacancyProfession) {
          params['vacancyProfession[id]'] = vacancyProfession
        }

        if (region) {
          params['region[id]'] = region
        }
        if (searchQuery) {
          params.searchQuery = searchQuery
        }

        params.isActive = isActive

        const response = await this.$store.dispatch(
          'organization/getVacancyList',
          { params }
        )

        this.modelList = response.data.map((item) => ({
          ...item,
          dateString: this.renderDateTime(item.createdAt),
          // status: item.externalId ? 'Отправлен' : 'Создан',
        }))

        if (response.headers['x-total-count']) {
          this.paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          this.paginatorTotal = this.footerProps.itemsPerPageOptions[1]
        }


        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    gotoOrganizationView (id) {
      const routeData = this.$router.resolve({ name: routeList.ORGANIZATION_VIEW_ROUTE_NAME, params: { id } })
      window.open(routeData.href, '_blank')
    },
    getMessage (message) {
      const max = 16
      if (!message || typeof message !== 'string') {
        return ''
      }
      if (message && message.length <= max) {
        return message
      }

      return `${message.substr(0, max)} ...`
    },
    renderMessage (message) {
      const max = 16
      if (!message || typeof message !== 'string') {
        return false
      }
      if (message && message.length <= max) {
        return false
      }

      return true
    },
    gotoView (item) {
      this.$router.push(
        {
          name: CLIENT_VACANCY_CREATED_ROUTE_NAME,
          params: { id: item.id, organizationId: item.organization.id },
          replace: true
        },
        () => {
        }
      )
    },
    goToForm () {
      if (!this.canCreate) {return}
      let organization
      if (this.propsOrganization) {
        organization = this.propsOrganization
      } else {
        organization = this.vacancyListFilterSet.organization
      }
      this.$router.push(
        {
          name: CLIENT_VACANCY_CREATED_ROUTE_NAME,
          params: { id: 'create', organizationId: organization.id },
          replace: true
        },
        () => {
        }
      )
    },
    async resetFilterSet () {
      const hasFilter = this.getActiveFilterNumber
      this.vacancyListFilterSet = {
        organization: null,
        region: null,
        searchQuery: null,
        isActive: null,
        vacancyProfession: null,
        state: null,
      }

      this.eventsBus.$emit(this.eventNames.VACANCY_PAGE_LIST_FILTER_RESET)

      if (hasFilter > 0) {
        await this.getVacancyList(1, this.options.itemsPerPage)
      }
    },
    manageCertification (data, vacancy) {
      this.onCertificationModalSuccess(
        data,
        vacancy.certification,
        async () => {
          await this.getVacancyList(1, this.options.itemsPerPage)
        }
      )
    },
    toggleFilters () {
      this.filterEnabled = !this.filterEnabled
    }
  }
}
</script>

